import { detect } from 'detect-browser';
import queryString from 'query-string';

export default class Utils {
  /** to get query from vue router in hash mode
   * queryString.parseUrl or .extract don't work in hash mode.
   */
  static getQuery(): { [key: string]: string } {
    const arr = window.location.hash.split('?');
    if (arr.length < 2) return {};
    const query = queryString.parse(arr[1]);

    return query as { [key: string]: string };
  }

  static getFormIdFromUrl(): string {
    try {
      return this.getFormIdFrom(window.location.hash);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  static getFormIdFrom(urlSuffix: string): string {
    const m = urlSuffix.match(/#?\/(form|bogen|playground)\/(.*)\/(.*)/);

    if (!m || m.length < 4) {
      throw new Error(`Unable to match formId in window.location.hash: ${window.location.hash}`);
    }
    const [formId] = m[3].split('?');

    return formId;
  }

  static isTouchDevice() {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (navigator as any).msMaxTouchPoints > 0
    );
  }

  static isIOS() {
    const browser = detect();
    return browser?.os === 'iOS';
  }

  // Format string in form '18.12.2000' to '2000-12-18'
  static formatBirthdate(birthdate: string) {
    const [day, month, year] = birthdate.split('.');
    const isoDate = new Date(`${year}-${month}-${day}`).toISOString();
    return isoDate.slice(0, 10);
  }

  // Format decimal height '1.8' to 180
  static formatHeight(height: number) {
    let formattedHeight = height;

    if (!Number.isInteger(height)) {
      // Convert height from decimal to centimeters
      formattedHeight = Math.round(height * 100);
    }
    return formattedHeight;
  }

  /** for use in JSON.stringify when serializing something containing Maps */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  static mapReplacer(_key: string, value: any) {
    if (value instanceof Map) {
      return {
        dataType: 'Map',
        value: Array.from(value.entries()), // or with spread: value: [...value]
      };
    }
    return value;
  }

  /** for use in JSON.parse when deserializing something that was serialized with mapReplacer */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  static mapReviver(_key: string, value: any) {
    if (typeof value === 'object' && value !== null) {
      if (value.dataType === 'Map') {
        return new Map(value.value);
      }
    }
    return value;
  }

  static isUrl(input: string): boolean {
    try {
      const url = new URL(input);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (_e) {
      return false;
    }
  }
}
